import { render, staticRenderFns } from "./investorEventDetail.vue?vue&type=template&id=0d6f5ce0"
import script from "./investorEventDetail.vue?vue&type=script&lang=js"
export * from "./investorEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports